import Vue from "vue";
import Vuex from "vuex";
import router from "./router.js";
import firebase from "firebase/app";
import db from "./firebase/init.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    userId: null,
    userRole: null,
    userCallCenterOnline: null,
    userCallCenterCompanies: null,
    userPermissions: null,
    userName: null,
    userFirstName: null,
    userLastName: null,
    userCompanies: null,
    userCompany: null,
    userCompanyName: null,
    userOperator: false,
    userBranches: [],
    userAbb: null,
    error: false,
    companyPrimaryColor: null,
    companySecondaryColor: null,
    companyPrimaryColorRGBA: null,
    companySecondaryColorRGBA: null,
    companyPackages: null,
    companyTrials: null,
    companyType: null,
    menuOpen: false,
    authenticated: false,
    demoMode: false,
    activeCompanyData: {},
    activeBranchData: {},
    userCompanies: [],
  },

  mutations: {
    authUser(state, userData) {
      state.userName = userData.userName;
      state.userRole = userData.userRole;
      state.userPermissions = userData.userPermissions;
      state.userCompanies = userData.userCompanies;
      state.userCompany = userData.userCompany;
      state.userBranches = userData.userBranches;
      state.userId = userData.userId;
      state.userFirstName = userData.userFirstName;
      state.userLastName = userData.userLastName;
      state.userAbb = userData.userAbb;
      state.userOperator = userData.userOperator;
      state.userCallCenterOnline = userData.userCallCenterOnline;
      state.userCallCenterCompanies = userData.userCallCenterCompanies;
    },
    authUserAuth(state, userData) {
      state.authenticated = userData.authenticated;
    },
    authUserError(state, userData) {
      state.error = userData.error;
    },

    companySettings(state, userData) {
      state.userCompanyName =  userData.userCompanyName;
      state.companyPrimaryColor = userData.companyPrimaryColor;
      state.companySecondaryColor = userData.companySecondaryColor;
      state.companyPrimaryColorRGBA = userData.companyPrimaryColorRGBA;
      state.companySecondaryColorRGBA = userData.companySecondaryColorRGBA;
      state.companyPackages = userData.companyPackages;
      state.companyTrials = userData.companyTrials;
      state.companyType = userData.companyType;
    },

    setActiveCompanyData(state, companyData) {
      state.activeCompanyData = companyData.activeCompanyData;
    },

    setActiveBranchData(state, branchData) {
      state.activeBranchData = branchData.activeBranchData;
    },

    menuOpen(state, menuData) {
      state.menuOpen = menuData.status;
    },
    demoMode(state, demoData) {
      state.demoMode = demoData.status;
    },

    onlineCallUserStatus(state, userData) {
      state.userCallCenterOnline = userData.status;
    },

    clearAuthData(state) {
      state.userName = null
      state.authenticated = false;
      state.userRole = null;
      state.userPermissions = null;
      state.userCompanies = null;
      state.userCompany = null;
      state.userCompanyName = null;
      state.userId = null;
      state.userFirstName = null;
      state.userLastName = null;
      state.userAbb = null;
      state.userPrimaryColor = null;
      state.userSecondaryColor = null;
      state.error = false;
      state.userCallCenterOnline = null;
      state.userCallCenterCompanies = null;
      state.userOperator = false;
    }
  },

  actions: {
    userLogout({ commit }) {
      router.replace("/login");
      firebase  
        .auth()
        .signOut()
        .then(() => {
          commit("clearAuthData");
        });
    },

    async selectCompany({ commit, state }, companyId) {
      console.log("selectCompany: ", companyId);
      let activeCompanyData = null;
      let activeBranchData = null;
      let userBranches = [];
      if(companyId != state.activeCompanyData.id){ // Check if the company is already loaded

        await db.collection("companies").doc(companyId).get().then(doc => {
          if(doc.exists){
            activeCompanyData = {...doc.data(),id: doc.id};
          }
        })

        await db.collection("branches").where("compId", "==", activeCompanyData.id).get().then(querySnapshot => {
          querySnapshot.forEach(doc => {
            userBranches.push(
              {
                id: doc.id,
                name: doc.data().branchName,
              }
            );
            activeBranchData = {...doc.data(),id: doc.id};
          });
        });

        state.userBranches = userBranches;
        
        commit("setActiveCompanyData", {
          activeCompanyData: activeCompanyData
        });
        commit("setActiveBranchData", {
          activeBranchData: activeBranchData
        });
      }
      else{
        console.log("Company already loaded");
      }
      localStorage.setItem("4careActiveCompanyId", companyId);
      return;
    },

    async selectBranch({ commit, state }, branchId) {
      let activeBranchData = null;
      if(branchId != state.activeBranchData.id){ // Check if the company is already loaded
        await db.collection("branches").doc(branchId).get().then(doc => {
          if(doc.exists){
            activeBranchData = {...doc.data(),id: doc.id};
          }
        })
        
        commit("setActiveBranchData", {
          activeBranchData: activeBranchData
        });
        localStorage.setItem("4careActiveBranchId", branchId);
      }
      return;
    },
    
    async tryAutoLogin({ commit, state }, user) {
      if (state.userId == null) {
        let userId = null;
        let userName = null;
        let userFirstName = null;
        let userLastName = null;
        let userRole = null;
        let userAccessCompanies = [];
        let userAccessBranches = [];
        let userCompanies = [];
        let userCompany = null;
        let userBranches = [];
        let userAbb = null;
        let userPermissions = null;
        let userCallCenterOnline = false;
        let userCallCenterCompanies = null;
        let userOperator = false;

        await db
          .collection("users")
          .where("user_id", "==", user.uid)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              userId = doc.data().user_id;
              userName = doc.id;
              userFirstName = doc.data().firstName;
              userLastName = doc.data().lastName;
              userRole = doc.data().userRole;
              if(doc.data().callActive && doc.data().callActive == true){
                userCallCenterOnline = true
              }
              if(doc.data().callCompanies){
                userCallCenterCompanies = doc.data().callCompanies
              }
              userPermissions = doc.data().userPermissions;
              if (
                
                doc.data().userRole == "admin" ||
                doc.data().userRole == "employee" ||
                doc.data().userRole == "manager"
              ) {
                userAccessBranches = doc.data().branches;
              } 

              if(doc.data().userRole == "superadmin"){
                // Load all Branches Data
                // Load all Companies Data
              }
              else{
                userAccessCompanies = doc.data().accessCompanies;
              }
              userCompany = doc.data().company;
              

              if(doc.data().operator){
                userOperator = doc.data().operator
              }
              
             
              userAbb =
                doc.data().firstName.charAt(0) + doc.data().lastName.charAt(0);
            });
          })

          let activeCompanyData = null;
          let activeBranchDataBackup = null;
          let activeBranchData = null;

          if(userRole == "superadmin"){
            // Load all Companies Data
            await db.collection("companies").get().then(querySnapshot => {
              querySnapshot.forEach(doc => {
                userCompanies.push(
                  {
                    id: doc.id,
                    name: doc.data().name,
                  }
                );
                const previousSelectedCompany = localStorage.getItem("4careActiveCompanyId");
                if(previousSelectedCompany){
                  if(previousSelectedCompany == doc.id){
                    activeCompanyData = {...doc.data(),id: doc.id};
                  }
                }
                else{
                  if(doc.id == userCompany){
                    activeCompanyData = {...doc.data(),id: doc.id};
                    localStorage.setItem("4careActiveCompanyId", doc.id);
                  }
                }
              });
            });

            // Load active Company Branches
            await db.collection("branches").where("compId", "==", activeCompanyData.id).get().then(querySnapshot => {
              querySnapshot.forEach(doc => {
                userBranches.push(
                  {
                    id: doc.id,
                    name: doc.data().branchName,
                  }
                );
                const previousSelectedBranch = localStorage.getItem("4careActiveBranchId");
                if(previousSelectedBranch){
                  if(previousSelectedBranch == doc.id){
                    activeBranchData = {...doc.data(),id: doc.id,qcare: doc.data().qcare ? doc.data().qcare : {active: false}};
                    localStorage.setItem("4careActiveBranchId", doc.id);
                  }
                }
                else{
                  activeBranchData = {...doc.data(),id: doc.id,qcare: doc.data().qcare ? doc.data().qcare : {active: false}};
                  localStorage.setItem("4careActiveBranchId", doc.id);
                }
                activeBranchDataBackup =  {...doc.data(),id: doc.id,qcare: doc.data().qcare ? doc.data().qcare : {active: false}};
                
              });
            });
            if(!activeBranchData){
              activeBranchData = JSON.parse(JSON.stringify(activeBranchDataBackup));
              localStorage.setItem("4careActiveBranchId", activeBranchData.id);
            }


          }
          else{
            for(let i = 0; i < userAccessCompanies.length; i++){
              await db.collection("companies")
                .doc(userAccessCompanies[i])
                .get()
                .then(doc => {
                  userCompanies.push(
                    {
                      id: doc.id,
                      name: doc.data().name,
                    }
                  );
      
                    if(userAccessCompanies[i] == userCompany){
                      activeCompanyData = {...doc.data(),id: doc.id};
                      localStorage.setItem("4careActiveCompanyId", doc.id);
                    }
                  
                });
            }

            for(let i = 0; i < userAccessBranches.length; i++){
              await db.collection("branches")
                .doc(userAccessBranches[i])
                .get()
                .then(doc => {
                  userBranches.push(
                    {
                      id: doc.id,
                      name: doc.data().branchName,
                    }
                  );

                  activeBranchData = {...doc.data(),id: doc.id};
                  localStorage.setItem("4careActiveBranchId", doc.id);
                });
            }
          }

          const userCompanyName = activeCompanyData.name;

          activeCompanyData.branches = activeBranchData;

          commit("setActiveCompanyData", {
            activeCompanyData: activeCompanyData
          });


          commit("setActiveBranchData", {
            activeBranchData: activeBranchData
          });

          commit("companySettings", {
            userCompanyName: activeCompanyData.name,
            companyPrimaryColor: activeCompanyData.colors.primary.hex,
            companySecondaryColor: activeCompanyData.colors.secondary.hex,
            companyPrimaryColorRGBA: `rgba(${
              activeCompanyData.colors.primary.rgba.r
            },${activeCompanyData.colors.primary.rgba.g},${
              activeCompanyData.colors.primary.rgba.b},`,

            companySecondaryColorRGBA: `rgba(${
              activeCompanyData.colors.secondary.rgba.r
            },${activeCompanyData.colors.secondary.rgba.g},${
              activeCompanyData.colors.secondary.rgba.b},`,

            companyPackages: activeCompanyData.packages,
            companyTrials: activeCompanyData.trials,
            companyType: activeCompanyData.type
          });






      
            commit("authUser", {
              userId: userId,
              userName: userName,
              userFirstName: userFirstName,
              userLastName: userLastName,
              userRole: userRole,
              userPermissions: userPermissions,
              userCompanies: userCompanies,
              userCompany: userCompany,
              userCompanyName: userCompanyName,
              userBranches: userBranches,
              userAbb: userAbb,
              userCallCenterOnline: userCallCenterOnline,
              userCallCenterCompanies: userCallCenterCompanies,
              userOperator: userOperator
            });
            commit("authUserAuth", {
              authenticated: true
            });
   
      } else {
        // console.log("Updaten niet nodig");
      }
    },

    menuStatus({ commit }, status) {
      commit("menuOpen", {
        status: status
      });
    },

    demoMode({ commit }, status) {
      commit("demoMode", {
        status: status
      });
    },

    onlineCallStatus({ commit }, status) {
      commit("onlineCallUserStatus", {
        status: status
      });
    },


    login({ commit }, loginData) {
      if (loginData.remember == true) {
        // User wil be remebered in cache
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            firebase
              .auth()
              .signInWithEmailAndPassword(loginData.email, loginData.password)
              .then(() => {
                commit("authUserAuth", {
                  authenticated: true
                });
                commit("authUserError", {
                  error: false
                });
                
                if(loginData.destination){
                  let path = "/" + loginData.destination
                  // console.log("StorePath: ", path)
                  router.replace(path);
                }
                else{
                  router.replace("/dashboard");
                }
              })
              .then(() => {
                let userFirstNameLogin = null;
                let userLastNameLogin = null;
                let userRoleLogin = null;
                let userCompanyLogin = null;

                firebase.auth().onAuthStateChanged(user => {
                  if (user) {
                    db.collection("users")
                      .where("user_id", "==", user.uid)
                      .get()
                      .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                          userFirstNameLogin = doc.data().firstName;
                          userLastNameLogin = doc.data().lastName;
                          userRoleLogin = doc.data().userRole;
                          userCompanyLogin = doc.data().company;
                        });
                      })
                      .then(()=>{
                        if(userRoleLogin == 'superadmin'){
                          let selectedCompany = window.localStorage.getItem('selectedCompany')
                          if(!selectedCompany){
                            window.localStorage.setItem('selectedCompany', userCompanyLogin);
                          }
                        }
                      })
                      .then(() => {
                        db.collection("log").add({
                          time: new Date(),
                          logType: "info",
                          user: userFirstNameLogin + " " + userLastNameLogin,
                          userType: userRoleLogin,
                          company: userCompanyLogin,
                          actionType: "User Action",
                          action: "Login",
                          software: loginData.software,
                          browser: loginData.browser, 
  
                        });
                      });
                  }
                });
              })

              .catch(error => {
                console.error("firebase Auth Sign-in error: ", error);
                commit("authUserError", {
                  error: true
                });
                // let logError = error;
                let logEmail = loginData.email;
                let logPassword = loginData.password;
                console.error("Login error: ", error);
                db.collection("log").add({
                  time: new Date(),
                  logType: "loginerror",
                  loginEmail: logEmail,
                  user: "",
                  userType: "",
                  company: "",
                  actionType: "User Action",
                  software: loginData.software,
                  browser: loginData.browser, 
                  action: "Error logging in : " + logEmail,
                  extra:
                    "<b>INLOGGEGEVENS</b> " +
                    "<br>" +
                    "<b>Email: </b> " +
                    logEmail +
                    "<br>" +
                    "<b>Password: </b> " +
                    logPassword +
                    "<br><br>" +
                    "<b>ERROR</b> " +
                    "<br>" +
                    JSON.stringify(error)
                });
              });
          })
          .catch(error => {
            console.error("firebase Auth error: ", error);
          });
      } else {
        // User wil be remebered for one session
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.SESSION)
          .then(() => {
            return firebase
              .auth()
              .signInWithEmailAndPassword(loginData.email, loginData.password)
              .then(() => {
                commit("authUserAuth", {
                  authenticated: true
                });
                commit("authUserError", {
                  error: false
                });
                if(loginData.destination){
                  let path = "/" + loginData.destination
                  router.replace(path);
                }
                else{
                  router.replace("/dashboard");
                }
              })
              .then(() => {
                let userFirstNameLogin = null;
                let userLastNameLogin = null;
                let userRoleLogin = null;
                let userCompanyLogin = null;

                firebase.auth().onAuthStateChanged(user => {
                  if (user) {
                    db.collection("users")
                      .where("user_id", "==", user.uid)
                      .get()
                      .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                          userFirstNameLogin = doc.data().firstName;
                          userLastNameLogin = doc.data().lastName;
                          userRoleLogin = doc.data().userRole;
                          userCompanyLogin = doc.data().company;
                        });
                      })
                      .then(()=>{
                        if(userRoleLogin == 'superadmin'){
                          let selectedCompany = window.localStorage.getItem('selectedCompany')
                          if(!selectedCompany){
                            window.localStorage.setItem('selectedCompany', userCompanyLogin);
                          }
                        }
                      })
                      .then(() => {
                        db.collection("log").add({
                          time: new Date(),
                          logType: "info",
                          user: userFirstNameLogin + " " + userLastNameLogin,
                          userType: userRoleLogin,
                          company: userCompanyLogin,
                          actionType: "User Action",
                          action: "Login",
                          software: loginData.software,
                          browser: loginData.browser, 
                        });
                      });
                  }
                });
              })

              .catch(error => {
                console.error("firebase Auth Sign-in error: ", error);
                commit("authUserError", {
                  error: true
                });
                let logError = error;
                let logEmail = loginData.email;
                let logPassword = loginData.password;
                console.error("Login error: ", error);
                console.error("logError: ", logError);
                db.collection("log").add({
                  time: new Date(),
                  logType: "loginerror",
                  loginEmail: logEmail,
                  user: "",
                  userType: "",
                  company: "",
                  actionType: "User Action",
                  software: loginData.software,
                  browser: loginData.browser, 
                  action: "Error logging in : " + logEmail,
                  extra:
                    "<b>INLOGGEGEVENS</b> " +
                    "<br>" +
                    "<b>Email: </b> " +
                    logEmail +
                    "<br>" +
                    "<b>Password: </b> " +
                    logPassword +
                    "<br><br>" +
                    "<b>ERROR</b> " +
                    "<br>" +
                    JSON.stringify(error)
                });
              });
          })
          .catch(error => {
            console.error("firebase Auth error: ", error);
          });
      }
    }
  }
});
